import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { IconButton, Typography, Tooltip } from "@mui/material";
import { Accordion, Table } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import StatusDropdown from "../Common/StatusDropdown";

const TransferLotBarrels: React.FC = () => {
    
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [transferLotLogs, setTransferLotLogs] = useState<any>(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
   
    useEffect(() => {
        getAllOwnershipTransferLotBarrelsLog(id);
    }, [id]);

    const getAllOwnershipTransferLotBarrelsLog = async (transferLotRequestId: any) => {
        try {
            const response = await InventoryApiService.getAllOwnershipTransferLotBarrels(transferLotRequestId);
            setTransferLotLogs(response.data);
            console.log(transferLotLogs);
        } catch (error) {
            console.error("Failed to fetch barrel sync logs", error);
        }
    };
    const handleRowClick = (id) => {
        // If clicking the already active row, close it
        setActiveRowIndex(activeRowIndex === id ? null : id);
    };

    const handleBack = () => {
        history.push(`/master/transfer-lot-logs/`+ transferLotLogs?.transferRequestId);
    };

    return (
        <>
            <div className="usersList position-relative log-panel">
                <div className="usersList__header--wrapper detail-page-header--wrapper d-flex">
                    <div className="usersList__header--inner d-flex justify-content-between gap-4">
                        <div className="d-flex align-items-center gap-1">
                            <div className="back__button me-1">
                                <IconButton
                                    onClick={handleBack}
                                    aria-label="ArrowBackIcon"
                                    sx={{ backgroundColor: "#FFF" }}
                                >
                                    <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                </IconButton>
                            </div>
                            <div className="header--title me-3">
                                <h1 className="title mb-0 text-nowrap">
                                    Container Lot Details
                                    <i className="bi bi-heart-fill"></i>
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center flex-column flex-lg-row justify-content-lg-between w-100 gap-2 gap-lg-0">
                        <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
                            <div className="time__details me-3 me-xl-4 mb-0">
                                <Typography
                                    variant="h6"
                                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                                >
                                    Transfer Id
                                </Typography>
                                <Typography
                                    variant="h3"
                                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                                >
                                    {transferLotLogs?.khTransferId ?? "--"}
                                </Typography>
                            </div>
                            <div className="company__details me-3 me-xl-4 mb-0">
                                <Typography
                                    variant="h6"
                                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                                >
                                    New Owner Name
                                </Typography>
                                <Typography
                                    variant="h3"
                                    sx={{
                                        color: "#333333",
                                        fontSize: { xl: "18px", xs: "16px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    {transferLotLogs?.newCompanyName ?? "--"}
                                </Typography>
                            </div>
                            <div className="person__details me-3 me-xl-4 mb-0">
                                <Typography
                                    variant="h6"
                                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                                >
                                    Old Owner Name
                                </Typography>
                                <Typography
                                    variant="h3"
                                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                                >
                                    {transferLotLogs?.oldCompanyName ?? "--"}
                                </Typography>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper viewServiceRequest--wrapper viewSupport-req log-panel">
                    <div>
                        <div className="view-sample-request m-0" style={{ zIndex: "10", position: "relative" }}>

                            <div className="row m-0 mb-3">
                                <div className="col-12 px-0">
                                    <div className="inventory-file-list-table">
                                        <div className="table-responsive service-detail-table-wrapper">

                                            <Table className="service-detail-table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Lot No.</th>
                                                        <th className="text-nowrap ">Quantity</th>
                                                        <th className="text-nowrap ">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <React.Fragment>
                                                        <tr
                                                            style={{
                                                                borderColor:
                                                                    activeRowIndex === id
                                                                        ? "transparent"
                                                                        : "#E4E4DD",
                                                            }}>
                                                            <td className="text-start">{transferLotLogs?.lotNo ?? "--"}</td>
                                                            <td className="text-nowrap">

                                                                <button onClick={() => handleRowClick(id)} className="barrel-count-btn ms-1"
                                                                    style={{
                                                                        borderColor:
                                                                            activeRowIndex === id
                                                                                ? "#3A809E"
                                                                                : "#8F9195",
                                                                        color:
                                                                            activeRowIndex === id
                                                                                ? "#3A809E"
                                                                                : "#737376"
                                                                    }}>
                                                                    <span className="p-1">
                                                                        {transferLotLogs?.quantity ?? "--"}
                                                                        <img src={ExpandMore} alt="CompanyIcn" width={15} height={8} />
                                                                    </span>

                                                                </button>
                                                            </td>
                                                            <td className="text-start">
                                                                <div className="dropdown-nospacing" onClick={(e) => e.stopPropagation()}>
                                                                    <StatusDropdown
                                                                    currentStatus={transferLotLogs?.status}
                                                                    onStatusChange={(e) => console.log(e)}
                                                                    disableCondition={true}
                                                                    allowedLabels={[]}
                                                                    />
                                                                </div> 
                                                                {transferLotLogs?.status === "FAILED" && transferLotLogs?.reason && (
                                                                    <Tooltip title={`Reason: ${transferLotLogs?.reason}`} arrow>
                                                                        <StickyNote2Icon
                                                                            className="note-icon cursor-pointer"
                                                                            style={{ color: "gray" }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        {activeRowIndex === id && (
                                                            <tr className="total-barrel-wrapper">
                                                                <td colSpan={3}>
                                                                    <Accordion activeKey={activeRowIndex !== null ? "0" : null}>
                                                                        <Accordion.Item eventKey="0">
                                                                            <Accordion.Body>
                                                                                <div className="total-barrel-list-wrapper">
                                                                                    <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                                                        {transferLotLogs?.barrelNumbers?.map((barrel, barrelIndex) => (
                                                                                            <div key={barrelIndex} className="barrel-list-item">
                                                                                                {barrel}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    </Accordion>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                    {/* </div>
                                      </div> */}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransferLotBarrels;